module.exports = __webpack_public_path__ + "static/media/home-banner-img-5.c234cc8e.jpg";